import * as admin from "./admin/index";
import * as adminPbl from "./admin-pbl/index";

/** Base 객체 (기존 Admin) */
export const Base = {
  Button: admin.BaseButton,
  Checkbox: admin.BaseCheckbox,
  DateInput: admin.BaseDateInput,
  ExcelDown: admin.BaseExcelDown,
  File: admin.BaseFile,
  Input: admin.BaseInput,
  Popup: admin.BasePopup,
  Radio: admin.BaseRadio,
  SearchForm: admin.BaseSearchForm,
  Select: admin.BaseSelect,
  Tab: admin.BaseTab,
  Table: admin.BaseTable,
  TimeInput: admin.BaseTimeInput,
  TinyEditor: admin.BaseTinyEditor,
  ToggleSwitch: admin.BaseToggleSwitch,
  TableConfig: admin.BaseTableConfig,
};

/** LmsBase 객체 (LMS 전용) */
export const LmsBase = {
  Button: adminPbl.BaseButton,
  Input: adminPbl.BaseInput,
  SearchForm: adminPbl.BaseSearchForm,
  Checkbox: adminPbl.BaseCheckbox,
  Pagination: adminPbl.BasePagination,
  PaginationBar: adminPbl.BasePaginationBar,
  Tab: adminPbl.BaseTab,
  Select: adminPbl.BaseSelect,
  CourseSelect: adminPbl.BaseCourseSelect,
  SearchSelect: adminPbl.BaseSearchSelect,
  Chips: adminPbl.BaseChips,
  Dialog: adminPbl.BaseDialog,
  Snackbar: adminPbl.BaseSnackbar,
  Empty: adminPbl.BaseEmpty,
  FieldError: adminPbl.BaseFieldError,
  FieldInfo: adminPbl.BaseFieldInfo,
  FileAttach: adminPbl.BaseFileAttach,
  RangeDatePicker: adminPbl.BaseRangeDatePicker,
  DatePicker: adminPbl.BaseDatePicker,
  Breadcrumb: adminPbl.BaseBreadcrumb,
  PageHeader: adminPbl.BasePageHeader,
  ActionButtons: adminPbl.BaseActionButtons,
  Dropzone: adminPbl.BaseDropzone,
  FileChipList: adminPbl.BaseFileChipList,
  ImagePreview: adminPbl.BaseImagePreview,
  FileDropAttach: adminPbl.BaseFileDropAttach,
  SelectCard: adminPbl.BaseSelectCard,
  Textarea: adminPbl.BaseTextarea,
  ReviewModal: adminPbl.BaseModal,
};
